import { DemoExample } from "@/components/sections/DemoSection";

export const linkedinHeadshotDemo: DemoExample = {
    label: "LinkedIn Headshot",
    beforeImage: "/images/demos/linkedin/linkedin-before.webp",
    afterImage: "/images/demos/linkedin/linkedin-after.webp",
    title: "Selfie to Professional Headshot",
    description: "Transform casual photos into corporate-quality LinkedIn headshots.",
    alt: "Before and after LinkedIn headshot transformation"
};

export const glareRemovalDemo: DemoExample = {
    label: "Glare Removal",
    beforeImage: "/images/demos/glare-removal/glare-before.webp",
    afterImage: "/images/demos/glare-removal/glare-after.webp",
    title: "Remove Glare from Glasses",
    description: "Clear reflections from glasses to reveal natural eyes.",
    alt: "Before and after removing glare from glasses"
};

export const passportPhotoDemo: DemoExample = {
    label: "Passport Photo",
    beforeImage: "/images/demos/passport/passport-messy-before.webp",
    afterImage: "/images/demos/passport/passport-white-after.webp",
    title: "Professional Passport Photo",
    description: "Convert casual photos into compliant professional passport photos with white background.",
    alt: "Before and after passport photo conversion"
};

export const realEstatePhotoDemo: DemoExample = {
    label: "Real Estate Photo",
    beforeImage: "/images/demos/real-estate/real-estate-gloomy-before.webp",
    afterImage: "/images/demos/real-estate/real-estate-bright-after.webp",
    title: "Brighten Real Estate Photos",
    description: "Transform dark, gloomy interior photos into bright, inviting spaces that sell.",
    alt: "Before and after real estate photo brightening"
};

export const linkedinHeadshotDemo2: DemoExample = {
    label: "LinkedIn Headshot",
    beforeImage: "/images/demos/linkedin-2/linkedin-outdoor-before.png",
    afterImage: "/images/demos/linkedin-2/linkedin-professional-after.png",
    title: "Casual to Professional",
    description: "Transform casual outdoor photos into polished, professional LinkedIn headshots.",
    alt: "Before and after LinkedIn headshot transformation"
};

export const glareRemovalDemo2: DemoExample = {
    label: "Glare Removal",
    beforeImage: "/images/demos/glare-removal-2/glare-glasses-before.png",
    afterImage: "/images/demos/glare-removal-2/glare-glasses-after.png",
    title: "Clear Vision",
    description: "Remove distracting glare and reflections from glasses for a perfect portrait.",
    alt: "Before and after removing glare from glasses"
};

export const changeTextDemo: DemoExample = {
    label: "Change Text",
    beforeImage: "/images/demos/change-text/change-text-cake-before.png",
    afterImage: "/images/demos/change-text/change-text-cake-after.png",
    title: "Edit Text in Image",
    description: "Seamlessly change text on cakes, signs, and documents while preserving the original style.",
    alt: "Before and after changing text on a birthday cake"
};

export const addDeceasedDemo: DemoExample = {
    label: "Add Person",
    beforeImage: "/images/demos/add-deceased/add-deceased-family-before.png",
    afterImage: "/images/demos/add-deceased/add-deceased-family-after.png",
    title: "Add Deceased Loved One",
    description: "Combine photos to bring everyone together in one special memory.",
    alt: "Before and after adding a deceased loved one to a family photo"
};

export const christmasDemo: DemoExample = {
    label: "Christmas Theme",
    beforeImage: "/images/demos/christmas/christmas-family-before.png",
    afterImage: "/images/demos/christmas/christmas-family-after.png",
    title: "Christmas Magic",
    description: "Add holiday cheer, decorations, and Santa hats to your family photos.",
    alt: "Before and after adding Christmas decorations to a family photo"
};

export const removeExDemo: DemoExample = {
    label: "Remove Ex",
    beforeImage: "/images/demos/remove-ex/remove-ex-couple-before.png",
    afterImage: "/images/demos/remove-ex/remove-ex-couple-after.png",
    title: "Remove Ex-Partner",
    description: "Erase unwanted ex-partners from your favorite photos seamlessly.",
    alt: "Before and after removing ex-partner from a couple photo"
};

export const datingProfileDemo: DemoExample = {
    label: "Dating Profile",
    beforeImage: "/images/demos/dating-profile/dating-profile-before.png",
    afterImage: "/images/demos/dating-profile/dating-profile-after.png",
    title: "Dating Profile Glow-up",
    description: "Transform average photos into eye-catching dating profile pictures that get matches.",
    alt: "Before and after dating profile photo enhancement"
};

export const fixClosedEyesDemo: DemoExample = {
    label: "Fix Closed Eyes",
    beforeImage: "/images/demos/fix-closed-eyes/closed-eyes-group-before.png",
    afterImage: "/images/demos/fix-closed-eyes/closed-eyes-group-after.png",
    title: "Open Eyes Naturally",
    description: "Fix blinked eyes in group photos by seamlessly opening them with a natural look.",
    alt: "Before and after fixing closed eyes in a group photo"
};

export const tattooMockupDemo: DemoExample = {
    label: "Tattoo Mockup",
    beforeImage: "/images/demos/tattoo-mockup/tattoo-skin-before.png",
    afterImage: "/images/demos/tattoo-mockup/tattoo-skin-after.png",
    title: "Visualize Ink",
    description: "See exactly how a tattoo will look on your body before you commit to the ink.",
    alt: "Before and after tattoo mockup on skin"
};

export const screenshotCleanerDemo: DemoExample = {
    label: "Clean Screenshot",
    beforeImage: "/images/demos/screenshot-cleaner/screenshot-clutter-before.png",
    afterImage: "/images/demos/screenshot-cleaner/screenshot-clutter-after.png",
    title: "De-clutter Screenshots",
    description: "Remove notifications, volume bars, and other overlays from your screenshots.",
    alt: "Before and after cleaning up a mobile screenshot"
};

export const fixAiErrorsDemo: DemoExample = {
    label: "Fix AI Errors",
    beforeImage: "/images/demos/fix-ai-errors/ai-glitch-before.png",
    afterImage: "/images/demos/fix-ai-errors/ai-glitch-after.png",
    title: "Correct AI Glitches",
    description: "Fix common AI generation errors like extra fingers, distorted faces, or weird artifacts.",
    alt: "Before and after fixing AI generation errors"
};

export const noiseReductionDemo: DemoExample = {
    label: "Noise Reduction",
    beforeImage: "/images/demos/enhancement/enhance-before.webp",
    afterImage: "/images/demos/enhancement/enhance-after.webp",
    title: "Crystal Clear Photos",
    description: "Remove digital noise and grain from low-light photos while preserving details.",
    alt: "Before and after noise reduction on a grainy photo"
};

export const watermarkRemovalDemo: DemoExample = {
    label: "Watermark Removal",
    beforeImage: "/images/demos/watermark/watermark-photo-before.png",
    afterImage: "/images/demos/watermark/watermark-photo-after.png",
    title: "Clean Removal",
    description: "Remove watermarks, logos, and text overlays from images seamlessly.",
    alt: "Before and after watermark removal"
};

export const motionBlurFixDemo: DemoExample = {
    label: "Motion Blur Fix",
    beforeImage: "/images/demos/motion-blur/motion-blur-before.png",
    afterImage: "/images/demos/enhancement/enhance-after.webp",
    title: "Sharpen Blurry Photos",
    description: "Fix motion blur and camera shake to restore sharpness to your photos.",
    alt: "Before and after motion blur fix"
};

export const imageUpscalingDemo: DemoExample = {
    label: "Image Upscaling",
    beforeImage: "/images/demos/upscaling/upscaling-before.png",
    afterImage: "/images/demos/enhancement/enhance-after.webp",
    title: "4K Upscaling",
    description: "Upscale low-resolution images to 4K quality with AI enhancement.",
    alt: "Before and after image upscaling to 4K"
};

export const perspectiveCorrectionDemo: DemoExample = {
    label: "Perspective Correction",
    beforeImage: "/images/demos/real-estate/real-estate-gloomy-before.webp",
    afterImage: "/images/demos/real-estate/real-estate-bright-after.webp",
    title: "Fix Perspective",
    description: "Correct distorted perspectives and straighten architectural photos.",
    alt: "Before and after perspective correction"
};

export const cloneDuplicateDemo: DemoExample = {
    label: "Clone & Duplicate",
    beforeImage: "/images/demos/crowd-removal/crowd-removal-after.webp",
    afterImage: "/images/demos/crowd-removal/crowd-removal-before.webp",
    title: "Clone Objects",
    description: "Duplicate and clone objects seamlessly within your photos.",
    alt: "Before and after cloning objects"
};

export const imageMergeDemo: DemoExample = {
    label: "Image Merge",
    beforeImage: "/images/demos/add-deceased/add-deceased-family-before.png",
    afterImage: "/images/demos/add-deceased/add-deceased-family-after.png",
    title: "Merge Photos",
    description: "Combine multiple images into stunning composites and collages.",
    alt: "Before and after merging photos"
};

export const faceSwapDemo: DemoExample = {
    label: "Face Swap",
    beforeImage: "/images/demos/face-swap/couple-park-before.png",
    afterImage: "/images/demos/face-swap/couple-park-after.png",
    title: "Swap Faces",
    description: "Seamlessly swap faces between photos with realistic results.",
    alt: "Before and after face swap"
};

export const faceSwapFriendsDemo: DemoExample = {
    label: "Face Swap Friends",
    beforeImage: "/images/demos/face-swap/friends-cafe-before.png",
    afterImage: "/images/demos/face-swap/friends-cafe-after.png",
    title: "Fun Face Swaps",
    description: "Swap faces with friends for fun and creative photos.",
    alt: "Before and after face swap with friends"
};

export const colorizePhotosDemo: DemoExample = {
    label: "Colorize Photos",
    beforeImage: "/images/demos/restoration/restoration-before.webp",
    afterImage: "/images/demos/restoration/restoration-after.webp",
    title: "Add Color",
    description: "Transform black and white photos into vibrant color images.",
    alt: "Before and after colorizing black and white photo"
};

export const hairEditingDemo: DemoExample = {
    label: "Hair Editing",
    beforeImage: "/images/demos/skin-smoothing/skin-smoothing-before.webp",
    afterImage: "/images/demos/skin-smoothing/skin-smoothing-after.webp",
    title: "Perfect Hair",
    description: "Change hair color, style, and remove flyaways for polished portraits.",
    alt: "Before and after hair editing"
};

export const clothingRecolorDemo: DemoExample = {
    label: "Clothing Recolor",
    beforeImage: "/images/demos/skin-smoothing/skin-smoothing-before.webp",
    afterImage: "/images/demos/skin-smoothing/skin-smoothing-after.webp",
    title: "Recolor Clothes",
    description: "Change clothing colors to match your style or brand perfectly.",
    alt: "Before and after clothing recolor"
};

export const bodyEditingDemo: DemoExample = {
    label: "Body Editing",
    beforeImage: "/images/demos/body-editing/fitness-woman-before.png",
    afterImage: "/images/demos/body-editing/fitness-woman-after.png",
    title: "Body Retouching",
    description: "Natural body retouching for confident, beautiful photos.",
    alt: "Before and after body editing"
};

export const textLogoAdditionDemo: DemoExample = {
    label: "Text & Logo",
    beforeImage: "/images/demos/change-text/change-text-cake-before.png",
    afterImage: "/images/demos/change-text/change-text-cake-after.png",
    title: "Add Text & Logos",
    description: "Add professional text, watermarks, and logos to your images.",
    alt: "Before and after adding text and logos"
};

export const productPhotosDemo: DemoExample = {
    label: "Product Photos",
    beforeImage: "/images/demos/background-removal/product-shoe-before.png",
    afterImage: "/images/demos/background-removal/product-shoe-before.png", // Placeholder
    title: "E-commerce Ready",
    description: "Professional product photo editing for online stores and catalogs.",
    alt: "Before and after product photo editing"
};
